import Marquee from "react-fast-marquee";
import { Plus } from "lucide-react";

const ITEMS = [
  "ONCOLOGY DETECTION",
  "CT / MRI / X-RAY / ULTRASOUND",
  "RADIOMICS",
  "DEEP CONVOLUTIONAL NETWORKS",
  "DICOM NATIVE",
  "PACS INTEGRATED",
  "EXPLAINABLE HEATMAPS",
  "HIPAA ALIGNED",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-slate-200 bg-ink py-5 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center gap-8 mx-8">
            <span className="font-display text-sm md:text-base font-semibold uppercase tracking-[0.25em] text-slate-600">
              {item}
            </span>
            <Plus className="w-4 h-4 text-brand" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
